// @ts-check
import React from 'react';
import { Text as BaseText } from '@react-pdf/renderer';
import textVariants from './textVariants';
import useTheme from '../../useTheme';

/**
 * @param {{
 * children: React.ReactNode;
 * variant?: keyof textVariants;
 * style?: import('@react-pdf/types').Style | (import('@react-pdf/types').Style )[];
 * [x: string]: any;
 * }} props
 */
export default function Text({
  children,
  variant = 'default',
  style,
  ...rest
}) {
  const { theme } = useTheme();
  const textStyle = theme?.components?.Text
    ? {
        ...theme?.components?.Text.base,
        ...theme?.components?.Text[variant],
      }
    : textVariants[variant];
  return (
    <BaseText
      style={[textStyle, ...(Array.isArray(style) ? style : [style])]}
      {...rest}
    >
      {children}
    </BaseText>
  );
}
